var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNavigationArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.941,
    height: 13.785
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 32289",
    fill: "none",
    stroke: "#333"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 6",
    d: "M0 7.015h19.667"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20",
    d: "M13.694.354l6.54 6.539-6.54 6.539"
  }))));
}

export default __webpack_public_path__ + "edf565fe3bbee6f11f2b12aad268cf80.svg";
export { SvgNavigationArrow as ReactComponent };